import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgUrl, STATUS_LABELS, fmtPct } from "../../lib/api";
import { ImageReveal, Reveal } from "./Reveal";

export const ProjectCard = ({ p, index = 0, large = false }) => (
  <Reveal delay={(index % 2) * 0.1} className={index % 2 === 1 && !large ? "md:mt-20" : ""}>
    <Link to={`/progetti/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group block">
      <div className="relative">
        {p.cover_full_graphic ? <img src={imgUrl(p.cover_image)} alt={`${p.title} — ${p.city}`} loading="lazy" className="w-full h-auto bg-cream" /> : <ImageReveal src={imgUrl(p.cover_image)} alt={`${p.title} — ${p.city}`} className={`${large ? "aspect-[16/9]" : "aspect-[4/5] md:aspect-[4/3]"} bg-beige`} imgClassName="group-hover:scale-[1.03] transition-transform duration-[1.4s] ease-out" />}
        <span className={`absolute ${p.cover_full_graphic ? "-top-3 left-1/2 -translate-x-1/2 whitespace-nowrap" : "top-5 left-5"} text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 backdrop-blur ${p.status === "concluso" ? "bg-ink/70 text-cream" : "bg-white/85 text-ink"}`}>
          {STATUS_LABELS[p.status]}
        </span>
        {p.roi && <span data-testid={`project-roi-badge-${p.slug}`} className={`absolute ${p.cover_full_graphic ? "-bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap" : "top-5 right-5"} text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 bg-gold text-ink`}>ROI {fmtPct(p.roi.roi_pct)}</span>}
      </div>
      <div className="mt-6 flex items-start justify-between gap-4">
        <div>
          <div className="eyebrow !text-stone">{p.city}{p.year ? ` — ${p.year}` : ""}</div>
          <h3 className="h-card mt-2 group-hover:text-gold transition-colors duration-300">{p.title}</h3>
          <p className="mt-3 text-sm md:text-base font-light text-ink/70 leading-relaxed max-w-md">{p.summary}</p>
        </div>
        <ArrowUpRight size={22} strokeWidth={1} className="mt-2 shrink-0 text-ink/40 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
      </div>
    </Link>
  </Reveal>
);
